var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3001 0.900391H8.9001C10.4001 0.900391 11.6001 2.10039 11.6001 3.60039V9.20039C11.6001 10.7004 10.4001 11.9004 8.9001 11.9004H3.3001C1.8001 11.9004 0.600098 10.7004 0.600098 9.20039V3.60039C0.700098 2.10039 1.9001 0.900391 3.3001 0.900391Z",
    stroke: "#FEFEFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69995 6.50039C3.69995 6.10039 3.89995 5.90039 4.19995 5.90039H8.19995C8.49995 5.90039 8.79996 6.10039 8.79996 6.50039C8.79996 6.80039 8.49995 7.00039 8.19995 7.00039H4.19995C3.89995 7.00039 3.69995 6.80039 3.69995 6.50039Z",
    fill: "#FEFEFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19985 9.00039C5.79985 9.00039 5.59985 8.70039 5.59985 8.40039V4.40039C5.59985 4.10039 5.79985 3.90039 6.19985 3.90039C6.49985 3.90039 6.69985 4.10039 6.69985 4.40039V8.40039C6.69985 8.70039 6.49985 9.00039 6.19985 9.00039Z",
    fill: "#FEFEFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.11d71b92a777c172f3ebeea19c88c229.svg";
export { ForwardRef as ReactComponent };